// @flow
import * as React from 'react'
import type { User } from 'types'
import LoginForm from 'ui/LoginForm'
import Modal, { WIDTH_CONSTRAINTS } from 'ui/Modal'
import { P } from 'ui/Typography'

const MODAL_TITLE = 'Log In'

type Props = {
  email?: string,
  autoCredentialCheck?: boolean,
  onRequestClose: () => void,
  onLogin?: User => void,
  redirectTo?: string,
  onShowSignUpModal?: () => void,
  children?: React.Node,
}

type State = {
  isOpen: boolean,
}

export default class LoginModal extends React.Component<Props, State> {
  state = {
    isOpen: true,
  }

  render = () => {
    return (
      <Modal
        isOpen={this.state.isOpen}
        title={MODAL_TITLE}
        widthConstraint={WIDTH_CONSTRAINTS.TIGHT}
        onRequestClose={this.props.onRequestClose}
      >
        {this.renderBody()}
      </Modal>
    )
  }

  renderBody = () => {
    if (!this.props.children) this.renderForm()

    return (
      <React.Fragment>
        <P>{this.props.children}</P>
        <P>{this.renderForm()}</P>
      </React.Fragment>
    )
  }

  closeModal = () => {
    this.setState({ isOpen: false })
  }

  renderForm = () => {
    return (
      <LoginForm
        source="login_modal"
        email={this.props.email}
        autoCredentialCheck={this.props.autoCredentialCheck}
        onLogin={this.props.onLogin}
        onShowSignUpModal={this.props.onShowSignUpModal}
        redirectTo={this.props.redirectTo}
      />
    )
  }
}
